import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('copy_to_clipboard', '.copy', (copy) => {
  copy.addEventListener('click', (e) => {
    const text = window.location
    navigator.clipboard
      .writeText(text)
      .then(() => {
        copy.classList.add('show-tooltip')
        setTimeout(() => {
          copy.classList.remove('show-tooltip')
        }, 2000)
      })
      .catch((err) => {
        console.error(`Error copying text to clipboard: ${err}`)
      })
  })
})
